var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.1666H14.175M14.5 11.6666H15C15.7766 11.6666 16.1649 11.6666 16.4711 11.7935C16.8795 11.9626 17.204 12.2871 17.3731 12.6954C17.5 13.0017 17.5 13.39 17.5 14.1666C17.5 14.9432 17.5 15.3314 17.3731 15.6377C17.204 16.0461 16.8795 16.3706 16.4711 16.5397C16.1649 16.6666 15.7766 16.6666 15 16.6666H5C4.22343 16.6666 3.83515 16.6666 3.52886 16.5397C3.12048 16.3706 2.79602 16.0461 2.62687 15.6377C2.5 15.3314 2.5 14.9432 2.5 14.1666C2.5 13.39 2.5 13.0017 2.62687 12.6954C2.79602 12.2871 3.12048 11.9626 3.52886 11.7935C3.83515 11.6666 4.22343 11.6666 5 11.6666H5.5M10 12.4999V3.33325M10 12.4999L7.5 9.99992M10 12.4999L12.5 9.99992",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9130ed30926635a383d2eb5414755118.svg";
export { ForwardRef as ReactComponent };